import { useLang } from "@/context/LangContext";

export default function Marquee() {
  const { t } = useLang();
  const PHRASES = t("marquee");
  const row = (
    <>
      {PHRASES.map((p) => (
        <span key={p} className="mx-10 flex items-center gap-10">
          <span className="font-serif text-2xl italic text-bone/70 sm:text-3xl">{p}</span>
          <span className="font-mono text-[10px] tracking-[0.3em] text-brass">+</span>
        </span>
      ))}
    </>
  );
  return (
    <div
      data-testid="editorial-marquee"
      className="relative overflow-hidden border-y border-bone/10 bg-ink-2 py-6"
    >
      <div className="flex w-max animate-marquee whitespace-nowrap">
        <div className="flex">{row}</div>
        <div className="flex" aria-hidden="true">{row}</div>
      </div>
    </div>
  );
}
